'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');
var enableSelfExclusion = require('../adapter/responsiblegaming/enableSelfExclusion.js');
var getTimeoutCategories = require('../adapter/responsiblegaming/getTimeoutCategories.js');
var session = require('../session/session.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class ResponsibleGaming {
  getTimeoutCategoriesAndDurations() {
    return __async(this, null, function* () {
      const [categories, periods] = yield Promise.all([
        this.getTimeoutCategories(),
        this.getTimeoutDurations()
      ]);
      return categories.map((category) => __spreadProps(__spreadValues({}, category), {
        period: periods.find(({ id }) => category.periodDurationID === id)
      }));
    });
  }
  getTimeoutCategories() {
    return index.adapter.responsibleGaming.getTimeoutCategories();
  }
  getTimeoutDurations() {
    return index.adapter.responsibleGaming.getTimeoutDurations();
  }
  enableTimeout(category) {
    const params = { selfExclusionCategoryId: category.id };
    return index.adapter.responsibleGaming.enableSelfExclusionCoolOff(params);
  }
  getSelfExclusionPeriods() {
    return index.adapter.responsibleGaming.getSelfExclusionPeriods();
  }
  enableSelfExclusion(category) {
    const params = { selfExclusionCategoryId: category.id };
    return index.adapter.responsibleGaming.enableSelfExclusion(params);
  }
  getSelfExclusionURL() {
    return index.adapter.responsibleGaming.getSelfExclusionURL();
  }
  getLimits() {
    return index.adapter.responsibleGaming.getLimits();
  }
  panicSelfExcludeAllBrands(reason) {
    return index.adapter.responsibleGaming.enableSelfExclusion({
      selfExclusionCategoryId: getTimeoutCategories.TimeoutCategory.ONE_DAY,
      blockReason: reason || enableSelfExclusion.BlockReason.PANIC_SELF_EXCLUSION
    });
  }
  panicSelfExcludeThisBrand(reason) {
    return index.adapter.responsibleGaming.enableSelfExclusionCoolOff({
      selfExclusionCategoryId: getTimeoutCategories.TimeoutCategory.ONE_DAY,
      blockReason: reason || enableSelfExclusion.BlockReason.PANIC_TIMEOUT
    });
  }
  lotbaPanicSelfExclusion() {
    return index.adapter.responsibleGaming.enableLotbaPanicSelfExclusion();
  }
  getUserLimits(limitRemainingAmount) {
    return index.adapter.responsibleGaming.getUserLimits(limitRemainingAmount);
  }
  removeLimit(limitId) {
    return index.adapter.responsibleGaming.removeLimit(limitId);
  }
  setUserLimits(limits) {
    return index.adapter.responsibleGaming.setUserLimits(limits);
  }
  setUserLimit(type, duration, limitAmount, userId) {
    const user = session.session.getUser();
    if (!userId && !user) {
      throw new Error("User not logged in or no userId given to setUserLimit call.");
    }
    const limit = {
      type,
      duration,
      limitAmount,
      userId: userId || user.userId
    };
    return index.adapter.responsibleGaming.setUserLimits([limit]);
  }
  getUserPlayStatsAndLimits(months) {
    return index.adapter.responsibleGaming.getUserPlayStatsAndLimits({ months });
  }
  awaitingUserLimitsConfirmation() {
    return __async(this, null, function* () {
      const limits = yield index.adapter.responsibleGaming.awaitingUserLimitConfirmation();
      return limits.map((limit) => {
        return __spreadProps(__spreadValues({}, limit), {
          limitType: limit.limitType.limitType,
          duration: limit.duration.durationType
        });
      });
    });
  }
  confirmUserLimits(payload) {
    return index.adapter.responsibleGaming.confirmUserLimits(payload);
  }
}
const responsibleGaming = new ResponsibleGaming();

exports.responsibleGaming = responsibleGaming;
